"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'profession.list.title': '职业',
    'profession.list.empty': '未找到职业',
};
